import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App/App";
import "./sass/global-styles.scss";

// only import font-face in development
// do not import font-face in production build since it's already loaded
if (import.meta.env.VITE_BUILD_MODE === "development") {
  console.log("dev fonts loaded");
  import("./sass/font-face-local.scss");
}

const root = ReactDOM.createRoot(
  // automatically inserts target div id from vite.config.js
  document.getElementById(__TARGET_DIV_ID__)
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
